import { JSX } from "react";

export const Search = (): JSX.Element => {
    return (
        <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.2778 12.8333L7.90278 8.45825C7.55556 8.73603 7.15625 8.95594 6.70486 9.11797C6.25347 9.28001 5.77315 9.36103 5.26389 9.36103C4.00231 9.36103 2.93461 8.92411 2.06076 8.05027C1.18692 7.17642 0.75 6.10871 0.75 4.84714C0.75 3.58557 1.18692 2.51786 2.06076 1.64402C2.93461 0.770173 4.00231 0.333252 5.26389 0.333252C6.52546 0.333252 7.59317 0.770173 8.46701 1.64402C9.34086 2.51786 9.77778 3.58557 9.77778 4.84714C9.77778 5.3564 9.69676 5.83672 9.53472 6.28811C9.37269 6.7395 9.15278 7.13881 8.875 7.48603L13.25 11.861L12.2778 12.8333ZM5.26389 7.97214C6.13194 7.97214 6.86979 7.66832 7.47743 7.06068C8.08507 6.45304 8.38889 5.7152 8.38889 4.84714C8.38889 3.97908 8.08507 3.24124 7.47743 2.6336C6.86979 2.02596 6.13194 1.72214 5.26389 1.72214C4.39583 1.72214 3.65799 2.02596 3.05035 2.6336C2.44271 3.24124 2.13889 3.97909 2.13889 4.84714C2.13889 5.7152 2.44271 6.45304 3.05035 7.06068C3.65799 7.66832 4.39583 7.97214 5.26389 7.97214Z"
                fill="#1D2D58"
            />
        </svg>
    );
};
